import { render, staticRenderFns } from "./entities-menu.vue?vue&type=template&id=3bb39ffb"
import script from "./entities-menu.component.ts?vue&type=script&lang=ts&external"
export * from "./entities-menu.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb39ffb')) {
      api.createRecord('3bb39ffb', component.options)
    } else {
      api.reload('3bb39ffb', component.options)
    }
    module.hot.accept("./entities-menu.vue?vue&type=template&id=3bb39ffb", function () {
      api.rerender('3bb39ffb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/admin/entities/entities-menu.vue"
export default component.exports